import { Box, Typography, styled } from "@mui/material";

export const PopupContainer = styled(Box)`
  background-color: #fff;
  color: #000;
  padding: 30px;
  border-radius: 4px;
`;

export const PopUpHeader = styled(Typography)`
  font-size: 20px;
  border-bottom: 1px solid lightgrey;
  padding-bottom: 5px;
`;

export const GridContainer = styled(Box)`
  display: grid;
  grid-template-columns: 1fr 10px 1fr 100px;
  gap: 10px;
  max-height: 80vh;
  overflow-y: auto;
  max-width: 70vw;
  margin: 20px 10px;
  border-radius: 0px;
`;

export const QuestionTypo = styled(Typography)`
  font-size: 15px;
  padding-bottom: 5px;
  color: #161616;
  word-break: break-word;
  padding: 2px;
`;

export const AnswerTypo = styled(Typography)`
  font-size: 15px;
  padding-bottom: 5px;
  color: #656565;
  word-break: break-word;
  padding: 2px;
`;

export const MaskedTypo = styled(Typography)`
  font-size: 12px;
  padding-bottom: 5px;
  color: #656565;
  word-break: break-word;
  padding: 2px;
`;
